import React from 'react';
import ReactGA from 'react-ga4';

function NavDropdown(props) {

    const handleClick = () => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked DropDown',
            label: 'Selected ' + props.children + ' from ' + props.name,
        });
    }

    const classDropdownMenu = 'dropdown-menu border-rounded';
    let isActive = '';
    const pageURI = window.location.pathname + window.location.search;
    var paths = pageURI.split('/');
    for (let nav of props.nav) {
        if (nav.path && paths.indexOf(nav.path.replace('/', '')) !== -1) {
            isActive = 'active';
            break;
        }
    }

    return (
        <li className={`nav-item dropdown ${isActive}`}>
            <a className="nav-link dropdown-toggle" onClick={() => handleClick()} href="/" id="navbarDropdown" role="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                {props.name}
            </a>
            <div className={classDropdownMenu} aria-labelledby="navbarDropdown">
                {props.children}
            </div>
        </li>
    )
}

export default NavDropdown;